import { inject, Injectable } from "@angular/core";
import { ApiService } from "@shared/data-access/api.service";
import { urlErp } from "@shared/utils/general/url";

const baseUrl = `${urlErp}/usuario`

@Injectable({ providedIn: 'root' })
export class UsuarioService {

    private api = inject(ApiService)

    saveAccess(access: string) {
        return this.api.put(`${baseUrl}/accesos-directos`, { accesos: access })
    }

    getAccess() {
        return this.api.get<{ message: string }>(`${baseUrl}/accesos-directos`)
    }
}
